export default __webpack_public_path__ + "static/media/Frame5.e87afade.png";